<div class="btn-group d-block" *ngIf="data['subscription_status']=='Active'">
  <!-- <button class="btn btn-info" (click)="onAction3($event)"><i class="fa fa-eye"></i></button> -->
  <button class="btn btn-danger popover-wrap-2" (click)="onAction2($event)" title="Cancel Subscription"><i class="fa fa-remove"></i><div class="popover-content top">Cancel Subscription</div></button>
</div>